import UserField from "kinnect-front/User/UserField";
import { FetchesData } from "kinnect-mixins";
import { User } from "kinnect-models";
import {
	KAddressFormBox,
	KBooleanToggle,
	KCombobox,
	KDatePicker,
	KForm,
	KFullscreenDialog,
	KPhoneField,
	KSelect,
	KTextField,
	KTextarea,
	KTimePicker
} from "kinnect-general";
import {
	VBtn,
	VCard,
	VCardText,
	VCardTitle,
	VCol,
	VDivider,
	VExpandTransition,
	VImg,
	VRow
} from "vuetify/lib";
import { compareAsc, parseISO } from "date-fns";

export default KForm.extend( {
	name: "KEmployeeInjuryReportForm",

	props: {
		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "safetyEmployeeInjuries" } ]
		},

		report: Object
	},

	mixins: [ FetchesData ],

	data: () => ( {
		formFields: {
			employeeAddress: null,
			employeeCity: null,
			employeeJobName: null,
			employeeJobNumber: null,
			employeeLat: null,
			employeeLng: null,
			employeePhone: null,
			employeeSsn: null,
			employeeState: null,
			employeeTitle: null,
			employeeType: null,
			employeeZip: null,
			hadPreviousPain: null,
			hadPreviousPainDesc: null,
			idUserAssignedJobDuty: null,
			idUserEmployee: null,
			idUserSupervisor: null,
			injuryArea: [],
			injuryBurn: [],
			injuryCaught: [],
			injuryCut: [],
			injuryDate: null,
			injuryFall: [],
			injuryFingersToes: [],
			injuryHow: null,
			injuryLocation: null,
			injuryMisc: [],
			injuryNature: [],
			injuryStrain: [],
			injuryStriking: [],
			injuryStruck: [],
			injuryTime: null,
			injuryVehicle: [],
			injuryWhat: null,
			injuryWhen: null,
			injuryWhere: null,
			injuryWho: null,
			injuryWhy: null,
			reportedDate: null,
			startWorkTime: null,
			supervisorPhone: null,
			wasAssignedJobDuty: null,
			wasAssignedJobDutyDesc: null,
			wasSelfPreventable: null,
			wasSelfPreventableDesc: null,
			wereActionsPurposeOfCompany: null,
			wereActionsPurposeOfCompanyDesc: null,
			werePartOfRegularDuties: null,
			werePartOfRegularDutiesDesc: null
		},
		headerClasses: "text-subtitle-1 grey darken-4 white--text",
		employeeTypes: [ "Part-Time", "Full-Time" ],
		today: ( new Date() ).setHours( 0, 0, 0, 0 ),
		users: [],
		injuryTypes: {
			burn: [
				"Chemicals",
				"Hot Objects or Substance",
				"Temperature Extremes",
				"Fire or Flame",
				"Steam or Hot Fluids",
				"Welding Operation",
				"Radiation",
				"Cold Object or Substance",
				"Abnormal Air Pressure",
				"Electric Current"
			],
			cut: [
				"Broken Glass",
				"Hand Tool",
				"Object Being Lifted or Handled",
				"Powered Hand Tool, Appliance"
			],
			striking: [
				"Moving Parts of Machine",
				"Object Being Lifted or Handled",
				"Sanding, Scraping, Cleaning",
				"Stationary Object",
				"Stepping on Sharp Object",
				"Struck or Injured"
			],
			fall: [
				"From Different Level (Elevated)",
				"From Ladder or Scaffolding",
				"From Liquids or Grease Spill",
				"Into Opening",
				"On Same Level",
				"Slipped, Did Not Fall",
				"On Ice or Snow",
				"On Stairs"
			],
			struck: [
				"Fellow Worker",
				"Falling or Flying Object",
				"Hand Tool or Machine",
				"Motor Vehicle",
				"Moving Parts or Machine",
				"Objects Being Lifted or Handled",
				"Animal or Insect",
				"Explosion or Flareback"
			],
			caught: [
				"Machine or Machinery",
				"Object Handled",
				"Sliding or Moving Objects",
				"Slides of Earth (Trench)"
			],
			strain: [
				"Continual Noise",
				"Twisting",
				"Jumping",
				"Holding or Carrying",
				"Lifting",
				"Pushing or Pulling",
				"Reaching",
				"Using Tools or Machinery",
				"Wielding or Throwing",
				"Repetitive Motion"
			],
			vehicle: [
				"Collision or Sideswipe",
				"Collision with Fixed Object",
				"Vehicle Troubled"
			],
			misc: [
				"Ingestion or Inhalation",
				"Skin Absorption",
				"Foreign Matter in Eye(s)",
				"Mold",
				"Person in Act of a Crime",
				"Act of Terrorism",
				"Other than Physical Injury"
			]
		},
		injuryNatures: [
			"Amputation",
			"Contusion (Bruise)",
			"Laceration (Cut)",
			"Burn (Burn/Scald)",
			"Crushing (Crushed)",
			"Puncture",
			"Dislocation",
			"Fracture",
			"Asphyxiation",
			"Hernia",
			"Foreign Body (Irritant)",
			"Strain",
			"Sprain",
			"Angina Pectoris/Chest Pain",
			"Heart Attack",
			"Poisoning",
			"Concussion",
			"Electric Shock",
			"Freezing",
			"Hearing Loss or Impairment",
			"Heat Stress",
			"Infection",
			"Inflammation",
			"Rupture",
			"Vision Loss"
		],
		injuryAreas: [
			"Ear (Left)",
			"Ear (Right)",
			"Eye (Left)",
			"Eye (Right)",
			"Shoulder (Left)",
			"Shoulder (Right)",
			"Hip (Left)",
			"Hip (Right)",
			"Bicep (Left)",
			"Bicep (Right)",
			"Thigh (Left)",
			"Thigh (Right)",
			"Elbow (Left)",
			"Elbow (Right)",
			"Knee (Left)",
			"Knee (Right)",
			"Forearm (Left)",
			"Forearm (Right)",
			"Shin (Left)",
			"Shin (Right)",
			"Wrist (Left)",
			"Wrist (Right)",
			"Ankle (Left)",
			"Ankle (Right)",
			"Hand (Left)",
			"Hand (Right)",
			"Foot (Left)",
			"Foot (Right)",
			"Finger(s) (Left)",
			"Finger(s) (Right)",
			"Toe(s) (Left)",
			"Toe(s) (Right)",
			"Head",
			"Face",
			"Teeth",
			"Mouth",
			"Neck",
			"Chest",
			"Stomach",
			"Groin",
			"Back (Low)",
			"Back (Mid)",
			"Back (High)",
			"Respiratory",
			"Ingestion",
			"Heart",
			"Brain"
		],
		fingers: {
			left: [
				"Thumb (Left)",
				"Index Finger (Left)",
				"Middle Finger (Left)",
				"Ring Finger (Left)",
				"Pinky Finger (Left)"
			],
			right: [
				"Thumb (Right)",
				"Index Finger (Right)",
				"Middle Finger (Right)",
				"Ring Finger (Right)",
				"Pinky Finger (Right)"
			]
		},
		toes: {
			left: [
				"Big Toe (Left)",
				"Index Toe (Left)",
				"Middle Toe (Left)",
				"Fourth Toe (Left)",
				"Little Toe (Left)"
			],
			right: [
				"Big Toe (Right)",
				"Index Toe (Right)",
				"Middle Toe (Right)",
				"Fourth Toe (Right)",
				"Little Toe (Right)"
			]
		}
	} ),

	computed: {
		editing() {
			return Boolean( this.report );
		},

		injuryFingersToesItems() {
			const items = [];

			if ( this.formFields.injuryArea.indexOf( "Finger(s) (Left)" ) !== -1 ) {
				items.push( ...this.fingers.left );
			}

			if ( this.formFields.injuryArea.indexOf( "Finger(s) (Right)" ) !== -1 ) {
				items.push( ...this.fingers.right );
			}

			if ( this.formFields.injuryArea.indexOf( "Toe(s) (Left)" ) !== -1 ) {
				items.push( ...this.toes.left );
			}

			if ( this.formFields.injuryArea.indexOf( "Toe(s) (Right)" ) !== -1 ) {
				items.push( ...this.toes.right );
			}

			return items;
		},

		showFingersDiagram() {
			return this.formFields.injuryArea.indexOf( "Finger(s) (Left)" ) !== -1
				|| this.formFields.injuryArea.indexOf( "Finger(s) (Right)" ) !== -1;
		},

		showToesDiagram() {
			return this.formFields.injuryArea.indexOf( "Toe(s) (Left)" ) !== -1
				|| this.formFields.injuryArea.indexOf( "Toe(s) (Right)" ) !== -1;
		},

		genFingersDialog() {
			if ( !this.showFingersDiagram ) {
				return;
			}

			return <KFullscreenDialog
				scopedSlots={{
					activator: ( { on } ) => <VBtn on={on}>View fingers diagram</VBtn>
				}}
				title="Fingers Diagram"
			>
				<VRow
					align="center"
					class="fill-height ma-0"
					justify="center"
				>
					<VImg
						contain
						maxHeight="100%"
						maxWidth="100%"
						src={require( "@/assets/img/fingers.png" )}
					></VImg>
				</VRow>
			</KFullscreenDialog>;
		},

		genToesDialog() {
			if ( !this.showToesDiagram ) {
				return;
			}

			return <KFullscreenDialog
				scopedSlots={{
					activator: ( { on } ) => <VBtn on={on}>View toes diagram</VBtn>
				}}
				title="Toes Diagram"
			>
				<VRow
					align="center"
					class="fill-height ma-0"
					justify="center"
				>
					<VImg
						contain
						maxHeight="100%"
						maxWidth="100%"
						src={require( "@/assets/img/toes.png" )}
					></VImg>
				</VRow>
			</KFullscreenDialog>;
		},

		formUrl() {
			return this.editing
				? `safety/employee-injury-reports/${this.report.id}`
				: "safety/employee-injury-reports";
		}
	},

	watch: {
		report: {
			handler( report ) {
				if ( report ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( report.hasOwnProperty( key ) ) {
							this.formFields[key] = report[key];
						}
					} );
				}
			},
			immediate: true
		}
	},

	methods: {
		isNotFutureDate( date ) {
			return compareAsc( this.today, parseISO( date ) ) !== -1;
		},

		async fetchUsers() {
			this.users = await User.where( "approved", true ).get();
		},

		async fetch() {
			await this.fetchUsers();
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post"
			}}
			on={this.$listeners}
		>
			<VCard class="mt-4" outlined>
				<VCardTitle class={this.headerClasses}>
					Employee Information
				</VCardTitle>

				<VCardText>
					<VRow>
						<VCol class="py-0" cols={12} sm={6}>
							<UserField
								items={this.users}
								label="Employee*"
								loading={this.$wait.is( "get users" )}
								noDataText="No employees to display"
								required
								smallChips
								vModel={this.formFields.idUserEmployee}
								validationName="employee"
								validationRules="required"
							></UserField>
						</VCol>

						<VCol class="py-0" cols={12} sm={6}>
							<KTextField
								label="Title*"
								required
								vModel={this.formFields.employeeTitle}
								validationRules="required"
								validationName="title"
							></KTextField>
						</VCol>
					</VRow>

					<KAddressFormBox
						address={this.formFields.employeeAddress}
						addressLabel="Employee Address"
						city={this.formFields.employeeCity}
						cityLabel="Employee City"
						class="mb-4"
						lat={this.formFields.employeeLat}
						lng={this.formFields.employeeLng}
						on={{
							"update:address": val => this.formFields.employeeAddress = val,
							"update:city": val => this.formFields.employeeCity = val,
							"update:lat": val => this.formFields.employeeLat = val,
							"update:lng": val => this.formFields.employeeLng = val,
							"update:state": val => this.formFields.employeeState = val,
							"update:zip": val => this.formFields.employeeZip = val
						}}
						required
						state={this.formFields.employeeState}
						stateLabel="Employee State"
						zip={this.formFields.employeeZip}
						zipLabel="Employee Zip"
					></KAddressFormBox>

					<KSelect
						items={this.employeeTypes}
						label="Position Type*"
						required
						vModel={this.formFields.employeeType}
						validationName="employee position type"
						validationRules="required"
					></KSelect>

					<KTextField
						label="SS# (Last 4)*"
						required
						vModel={this.formFields.employeeSsn}
						validationName="SS#"
						validationRules="required|numeric|length:4"
					></KTextField>

					<KPhoneField
						label="Employee Phone Number*"
						required
						vModel={this.formFields.employeePhone}
						validationName="employee phone number"
						validationRules="required|phone"
					></KPhoneField>

					<KDatePicker
						datePickerProps={{
							allowedDates: this.isNotFutureDate
						}}
						textFieldProps={{
							label: "Date Reported*",
							required: true,
							validationName: "date reported",
							validationRules: "required"
						}}
						vModel={this.formFields.reportedDate}
					></KDatePicker>

					<VRow>
						<VCol class="py-0" cols={12} sm={6}>
							<KDatePicker
								datePickerProps={{
									allowedDates: this.isNotFutureDate
								}}
								textFieldProps={{
									label: "Date of Injury*",
									required: true,
									validationName: "date of injury",
									validationRules: "required"
								}}
								vModel={this.formFields.injuryDate}
							></KDatePicker>
						</VCol>

						<VCol class="py-0" cols={12} sm={6}>
							<KTimePicker
								textFieldProps={{
									label: "Time of Injury*",
									required: true,
									validationName: "time of injury",
									validationRules: "required"
								}}
								vModel={this.formFields.injuryTime}
							></KTimePicker>
						</VCol>
					</VRow>

					<KTimePicker
						textFieldProps={{
							label: "Start Time of Work*",
							required: true,
							validationName: "start time of work",
							validationRules: "required"
						}}
						vModel={this.formFields.startWorkTime}
					></KTimePicker>

					<VRow>
						<VCol class="py-0" cols={12} sm={6}>
							<UserField
								items={this.users}
								label="Supervisor*"
								loading={this.$wait.is( "get users" )}
								noDataText="No users to display"
								required
								smallChips
								vModel={this.formFields.idUserSupervisor}
								validationName="supervisor"
								validationRules="required"
							></UserField>
						</VCol>

						<VCol class="py-0" cols={12} sm={6}>
							<KPhoneField
								label="Supervisor Phone Number*"
								required
								vModel={this.formFields.supervisorPhone}
								validationName="supervisor phone number"
								validationRules="required|phone"
							></KPhoneField>
						</VCol>
					</VRow>

					<KTextField
						hint="Job location"
						label="Location Injury Occurred*"
						persistentHint
						required
						vModel={this.formFields.injuryLocation}
						validationName="location injury occurred"
						validationRules="required"
					></KTextField>

					<VRow>
						<VCol class="py-0" cols={12} sm={6}>
							<KTextField
								label="Job Name*"
								required
								vModel={this.formFields.employeeJobName}
								validationName="job name"
								validationRules="required"
							></KTextField>
						</VCol>

						<VCol class="py-0" cols={12} sm={6}>
							<KTextField
								label="Job Number*"
								required
								vModel={this.formFields.employeeJobNumber}
								validationName="job number"
								validationRules="required"
							></KTextField>
						</VCol>
					</VRow>
				</VCardText>
			</VCard>

			<VCard class="mt-4" outlined>
				<VCardTitle class={this.headerClasses}>
					Type of Injury (Select all that apply or type in other values)
				</VCardTitle>

				<VCardText>
					<KCombobox
						chips
						deletableChips
						items={this.injuryTypes.burn}
						label="Burn or Scald; Heat or Cold"
						multiple
						vModel={this.formFields.injuryBurn}
					></KCombobox>

					<KCombobox
						chips
						deletableChips
						items={this.injuryTypes.cut}
						label="Cut, Puncture, or Scrape"
						multiple
						vModel={this.formFields.injuryCut}
					></KCombobox>

					<KCombobox
						chips
						deletableChips
						items={this.injuryTypes.striking}
						label="Striking Against or Stepping On"
						multiple
						vModel={this.formFields.injuryStriking}
					></KCombobox>

					<KCombobox
						chips
						deletableChips
						items={this.injuryTypes.fall}
						label="Fall, Slip, or Trip"
						multiple
						vModel={this.formFields.injuryFall}
					></KCombobox>

					<KCombobox
						chips
						deletableChips
						items={this.injuryTypes.struck}
						label="Struck or Injured"
						multiple
						vModel={this.formFields.injuryStruck}
					></KCombobox>

					<KCombobox
						chips
						deletableChips
						items={this.injuryTypes.caught}
						label="Caught In, Under, or Between"
						multiple
						vModel={this.formFields.injuryCaught}
					></KCombobox>

					<KCombobox
						chips
						deletableChips
						items={this.injuryTypes.strain}
						label="Strain"
						multiple
						vModel={this.formFields.injuryStrain}
					></KCombobox>

					<KCombobox
						chips
						deletableChips
						items={this.injuryTypes.vehicle}
						label="Motor Vehicle"
						multiple
						vModel={this.formFields.injuryVehicle}
					></KCombobox>

					<KCombobox
						chips
						deletableChips
						items={this.injuryTypes.misc}
						label="Miscellaneous Causes"
						multiple
						vModel={this.formFields.injuryMisc}
					></KCombobox>
				</VCardText>
			</VCard>

			<VCard class="mt-4" outlined>
				<VCardTitle class={this.headerClasses}>
					Nature of Injury (Select all that apply or type in other values)
				</VCardTitle>

				<VCardText>
					<KCombobox
						chips
						deletableChips
						items={this.injuryNatures}
						label="Nature of Injury*"
						multiple
						required
						vModel={this.formFields.injuryNature}
						validationName="nature of injury"
						validationRules="required"
					></KCombobox>
				</VCardText>
			</VCard>

			<VCard class="mt-4" outlined>
				<VCardTitle class={this.headerClasses}>
					Area of Injury (Select all that apply or type in other values)
				</VCardTitle>

				<VCardText>
					<KCombobox
						chips
						deletableChips
						items={this.injuryAreas}
						label="Area of Injury*"
						multiple
						required
						vModel={this.formFields.injuryArea}
						validationName="area of injury"
						validationRules="required"
					></KCombobox>

					{Boolean( this.injuryFingersToesItems.length ) && <KSelect
						chips
						deletableChips
						items={this.injuryFingersToesItems}
						label="Fingers / Toes Injured*"
						multiple
						required
						vModel={this.formFields.injuryFingersToes}
						validationName="fingers / toes injured"
						validationRules="required"
					></KSelect>}

					{this.genFingersDialog}
					{this.genToesDialog}
				</VCardText>
			</VCard>

			<VCard class="mt-4" outlined>
				<VCardTitle class={this.headerClasses}>
					Questions
				</VCardTitle>

				<VCardText>
					<KBooleanToggle
						label="Were your actions at the time of injury for the purpose of the company?"
						required
						vModel={this.formFields.wereActionsPurposeOfCompany}
						validationName="question"
						validationRules="required"
					></KBooleanToggle>

					<KTextarea
						class="mt-2"
						label="Explain*"
						outline
						required
						vModel={this.formFields.wereActionsPurposeOfCompanyDesc}
						validationName="explanation"
						validationRules="required"
					></KTextarea>

					<VDivider class="mt-2 mb-4"></VDivider>

					<KBooleanToggle
						label="Were your activities part of regular duties?"
						required
						vModel={this.formFields.werePartOfRegularDuties}
						validationName="question"
						validationRules="required"
					></KBooleanToggle>

					<KTextarea
						class="mt-2"
						label="Explain*"
						outline
						required
						vModel={this.formFields.werePartOfRegularDutiesDesc}
						validationName="explanation"
						validationRules="required"
					></KTextarea>

					<VDivider class="mt-2 mb-4"></VDivider>

					<KBooleanToggle
						label="Were you assigned the job duty being performed during the accident?"
						required
						vModel={this.formFields.wasAssignedJobDuty}
						validationName="question"
						validationRules="required"
					></KBooleanToggle>

					<VExpandTransition>
						{this.formFields.wasAssignedJobDuty && <UserField
							items={this.users}
							label="Assigned Job Duty By*"
							loading={this.$wait.is( "get users" )}
							noDataText="No users to display"
							required
							vModel={this.formFields.idUserAssignedJobDuty}
							validationName="assigned job duty by"
							validationRules="required"
						></UserField>}
					</VExpandTransition>

					<KTextarea
						class="mt-2"
						label="Explain*"
						outline
						required
						vModel={this.formFields.wasAssignedJobDutyDesc}
						validationName="explanation"
						validationRules="required"
					></KTextarea>

					<VDivider class="mt-2 mb-4"></VDivider>

					<KBooleanToggle
						label="Have you, the employee, had any previous pain in the area of injury, prior to the accident?"
						required
						vModel={this.formFields.hadPreviousPain}
						validationName="question"
						validationRules="required"
					></KBooleanToggle>

					<KTextarea
						class="mt-2"
						label="Explain*"
						outline
						required
						vModel={this.formFields.hadPreviousPainDesc}
						validationName="explanation"
						validationRules="required"
					></KTextarea>

					<VDivider class="mt-2 mb-4"></VDivider>

					<KBooleanToggle
						label="Do you feel the injury could have been prevented by you?"
						required
						vModel={this.formFields.wasSelfPreventable}
						validationName="question"
						validationRules="required"
					></KBooleanToggle>

					<KTextarea
						class="mt-2"
						label="Explain*"
						outline
						required
						vModel={this.formFields.wasSelfPreventableDesc}
						validationName="explanation"
						validationRules="required"
					></KTextarea>
				</VCardText>
			</VCard>

			<VCard class="mt-4" outlined>
				<VCardTitle class={this.headerClasses}>
					Injury Information
				</VCardTitle>

				<VCardText>
					<KTextarea
						hint="Individuals other than yourself, equipment, and environment involved"
						label="WHO?*"
						outline
						persistentHint
						required
						vModel={this.formFields.injuryWho}
						validationName='"WHO?"'
						validationRules="required"
					></KTextarea>

					<KTextarea
						class="mt-2"
						hint="What is the extent of damage, type of injury?"
						label="WHAT?*"
						outline
						persistentHint
						required
						vModel={this.formFields.injuryWhat}
						validationName='"WHAT?"'
						validationRules="required"
					></KTextarea>

					<KTextarea
						class="mt-2"
						hint="Steps with timeline leading up to the injury"
						label="WHEN?*"
						outline
						persistentHint
						required
						vModel={this.formFields.injuryWhen}
						validationName='"WHEN?"'
						validationRules="required"
					></KTextarea>

					<KTextarea
						class="mt-2"
						hint="Where were you located details?"
						label="WHERE?*"
						outline
						persistentHint
						required
						vModel={this.formFields.injuryWhere}
						validationName='"WHERE?"'
						validationRules="required"
					></KTextarea>

					<KTextarea
						class="mt-2"
						hint="Why did this occur?"
						label="WHY?*"
						outline
						persistentHint
						required
						vModel={this.formFields.injuryWhy}
						validationName='"WHY?"'
						validationRules="required"
					></KTextarea>

					<KTextarea
						class="mt-2"
						hint="Casual factors; direct cause (energy sources, hazardous materials); indirect cause (unsafe acts, conditions)"
						label="HOW?*"
						outline
						persistentHint
						required
						vModel={this.formFields.injuryHow}
						validationName='"HOW?"'
						validationRules="required"
					></KTextarea>
				</VCardText>
			</VCard>
		</KForm>;
	}
} );
